import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { MeSchema } from '../shared/schemas/UserSchema.js';

export type MeType = z.infer<typeof MeSchema>;

export const getMe = defaultClient.query({
  url: 'ai-assistant/users/me' as const,
  method: 'GET',
  responseSchema: MeSchema,
});
